import { useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import type { Persistor } from 'redux-persist';

import type { RootState } from '../../reducers';

type ReduxStoreWithPersistor = {
  __persistor?: Persistor;
};

const useIsAfterReduxHydration = () => {
  const [isAfterReduxHydration, setIsAfterReduxHydration] = useState(false);
  const reduxStore = useStore<RootState>() as ReduxStoreWithPersistor;
  // eslint-disable-next-line no-underscore-dangle
  const persistor = reduxStore.__persistor;

  useEffect(() => {
    if (!persistor) return undefined;

    const update = () => setIsAfterReduxHydration(persistor.getState().bootstrapped);
    update();

    const unsubscribe = persistor.subscribe(update);
    return unsubscribe;
  }, [persistor]);
  return isAfterReduxHydration;
};

export default useIsAfterReduxHydration;
